"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fano": {
    "c1c55e54": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "marotta-di-fano": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fano"
    }],
    "8bfaf204": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "metaurilia": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "81a1f5a8": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-sasso": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fano"
    }],
    "e08498ac": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "torrette-di-fano": [{
      "hkey": "edfee68e",
      "slug": "metaurilia-ponte-sasso-torrette",
      "name": "Metaurilia-Ponte Sasso-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fano"
    }]
  }
};
exports["default"] = _default;